import styles from './section-description.module.scss';
import parse from "html-react-parser";
import {scrollToFormHandler} from "@helpers/scroll-to-form-handler.helper";
import Image from "next/image";
import SharedAnimation from "@components/shared/animation";
import {useEffect} from "react";
import animations from "./../animation/animations.module.scss";


// TODO: @Dmitry reuse this component in other places

type SectionDescriptionProps = {
    section: {
        title: string
        description: string;
        moveToId?: string;
        btnText?: string;
        cards: Array<{
            cardClass?: string;
            icon: string;
            title: string;
            description: string
            subItems?: Array<{
                icon: string;
                title: string;
            }>
        }>;
    };
    isDifferentColor?: boolean;
}

const SectionDescription = ({section, isDifferentColor = false}: SectionDescriptionProps): JSX.Element => {
    useEffect(() => {
        const toggleTransparency: () => void = (): void => {
            section.cards.forEach((card): void => {
                const block = document.getElementById(card.title);
                if (!block) return;

                const rect = block.getBoundingClientRect();
                const isVisible =
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= window.innerHeight &&
                    rect.right <= window.innerWidth;

                if (isVisible) {
                    block.classList.remove(styles.transparent);
                } else {
                    block.classList.add(styles.transparent);
                }
            });
        };

        window.addEventListener('scroll', toggleTransparency);
        return (): void => {
            window.removeEventListener('scroll', toggleTransparency);
        };
    }, [section.cards]);

    return (
        <SharedAnimation render={(ref) => (
            <div className={isDifferentColor ? styles.container : styles.containerDifferent}>
                <section ref={ref} className={`${styles.section} ${animations.scroll__animation}`}>
                    <div className={styles.section__wrapper}>
                        <h2 className={styles.section__wrapper__title}>{parse(section.title)}</h2>
                        <p className={styles.section__text}>{section.description}</p>
                        {section.btnText && section.moveToId && (
                            <button onClick={() => scrollToFormHandler(section.moveToId ?? '')}
                                    className={styles.section__wrapper__button}>
                                {section.btnText}
                            </button>
                        )}

                    </div>

                    <div className={styles.section__blocks}>
                        {section.cards.map((card) => (
                            <div key={card.title} className={styles.section__blocks__card} id={card.title}>
                                <div className={`${styles.section__blocks__card__header} ${styles[card!.cardClass ? card!.cardClass : '']}`}>
                                    <div className={styles.section__blocks__card__header__img}>
                                        <Image src={card.icon} alt={card.title} layout={'fill'} objectFit={'contain'} />
                                    </div>
                                    <p>{card.title}</p>
                                </div>
                                <div className={styles.section__blocks__card__info}>
                                    <h3 className={styles.section__blocks__card__info__title}>{card.title}</h3>
                                    <p className={styles.section__blocks__card__info__text}>{card.description}</p>
                                </div>
                                {(card.subItems ?? []).map((topic, index) => (
                                    <div key={index}>
                                        <div className={styles.section__blocks__card__wraper}>
                                            <div className={styles.section__blocks__card__wraper__topic}>
                                                <div className={styles.section__blocks__card__wraper__topic__img}>
                                                    <Image src={card.icon} alt={card.title} layout={'fill'} objectFit={'contain'} />
                                                </div>
                                                <p className={styles.section__blocks__card__wraper__topic__text}>{topic}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        )}/>
    );
}

export default SectionDescription;